import {
    Button, Card, CardContent, Grid, makeStyles, Typography,
    useMediaQuery, useTheme 
} from "@material-ui/core";
import { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import styles from "../styles";
import   '../components/PKGComparisonCard.css';
import Afribrand from "../../../assets/images/afriglobal.svg";
import Clinixbrand from "../../../assets/images/clinix.svg";
import Dnabrand from "../../../assets/images/dna.svg";
import Docbrand from "../../../assets/images/docbrand.svg";
import Echobrand from "../../../assets/images/echo.svg";
import Imagebrand from "../../../assets/images/imag.svg";
import Lancetbrand from "../../../assets/images/lancet.svg";
import Synlabbrand from "../../../assets/images/synlab.svg";
import Unionbrand from "../../../assets/images/union.svg";
import { Col , Row } from "react-bootstrap";

const useStyles = makeStyles((theme) => styles(theme));

export default function PKGComparisonCard({ _package, onAddToCart, onRemoveFromCart, enableHomeService, onAddHomeService, onRemoveHomeService }) {

    const [packageDetails, setPackageDetails] = useState()
    const history = useHistory()
    const classes = useStyles();
    const theme = useTheme();
    const [partnername, setPartnerName] = useState();
    const [isHomeSampleSelected, setIsHomeSampleSelected] = useState(false);
    const [addedToCart, setAddedToCart] = useState(false);
    const [homeSelectedServices, setSelectedHomeServices] = useState([]);
    const matchesMD = useMediaQuery(theme.breakpoints.down("md"));
    const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));
    const matchesXS = useMediaQuery(theme.breakpoints.down("xs"));

    const areaState = useSelector((state) =>
        state.area !== undefined && state.area.area !== undefined
            ? state.area.area
            : ""
    );

    useEffect(() => {
        if (_package && _package.package_details && _package.package_details.length > 0) {
            setPackageDetails(_package.package_details[0]);
            setPartnerName(_package.partner_name);
        }
    }, [_package]);

    return (
        <>
            <Grid
                // item
                // container
                // direction={matchesXS ? "row" : undefined}
                // alignItems={matchesSM ? "center" : undefined}
                // justifyContent={matchesSM ? "center" : undefined}
                container direction="column" alignItems="center" 
                spacing={2}
            >
                {/* <Grid
                    item
                    style={{
                        marginRight: matchesXS ? "0px" : "40px",
                        marginBottom: "40px",
                        
                    }}
                    className="col-xs-12 col-sm-6 col-md-12"
                > */}
                    <div className="container">
                        <Row >
                            <Col xs={12} md={12}
                            // className="col-md-12 col-xs-12" 
                            >
                           
                    <Card classes={{ root: classes.labPkgCard }}  >
                        <CardContent classes={{ root: classes.cardSetter }}>
                            <Grid container>
                                <Grid
                                    item
                                    container
                                    alignContent='center'
                                    justifyContent="center"
                                    alignItems="center"
                                    className={classes.pkgTitleContainer}
                                >
                                    <Grid item container
                                        alignContent='center'
                                        justifyContent="center"
                                        alignItems="center">
                                        {/* {partner && <img alt="icon" src={partner.logo} />} */}
                                        {_package.partner_name === "SYNLAB" ? (
                                            <img src={Synlabbrand} alt="Synlabbrand" />
                                        ) : _package.partner_name ===
                                            "ECHOLAB" ? (
                                            <img src={Echobrand} alt="Echobrand" />
                                        ) : _package.partner_name ===
                                            "UNION DIAGNOSTICS" ? (
                                            <img src={Unionbrand} alt="Unionbrand" />
                                        ) : _package.partner_name ===
                                            "IMAGE DIAGNOSTICS" ? (
                                            <img src={Imagebrand} alt="Imagebrand" />
                                        ) : _package.partner_name ===
                                            "DNA LABS" ? (
                                            <img src={Dnabrand} alt="Dnabrand" />
                                        ) : _package.partner_name === "CLINIX" ? (
                                            <img src={Clinixbrand} alt="Clinixbrand" />
                                        ) : _package.partner_name ===
                                            "CLINA LANCET" ? (
                                            <img src={Lancetbrand} alt="Lancetbrand" />
                                        ) : _package.partner_name ===
                                            "AFRIGLOBAL" ? (
                                            <img src={Afribrand} alt="Afribrand" />
                                        ) : _package.partner_name ===
                                            "DOCTALL" ? (
                                            <img src={Docbrand} alt="Docbrand" />
                                        ) : (
                                            <div className="heading-font-cheapest">
                                                {_package.partner_name}
                                            </div>
                                        )}
                                    </Grid>
                                    {/* <Typography className={classes.productTitle}>
                                        {_package.partner_name}
                                    </Typography> */}
                                </Grid>
                                <Grid item align="center" style={{ margin: "16px", border: '2px solid #E3EAF6', height: "auto", padding: "10px" }}>
                                    {
                                        packageDetails &&
                                        <>
                                            <Typography className={classes.productTitle22} style={{ textAlign: 'center' }}>{`${packageDetails.panel_name}`}</Typography>
                                            <Typography className={classes.productTitle}>{`(${packageDetails.package_type})`}</Typography>
                                        </>
                                    }
                                    <Typography variant="body1" style={{ textAlign: "left" }}>
                                        A simple finger-prick blood test that measures the male hormone testosterone
                                        - essential for libido, muscle mass, fertility and mood.
                                        {" "}
                                    </Typography>
                                </Grid>

                                <Grid
                                    item
                                    className={classes.labtitleContainer}
                                    style={{ padding: "8px", margin: "16px", cursor: 'pointer', height: "150px", overflowY: "scroll" ,color:"#FF5C3C"}}
                                >
                                    <Typography variant="h6" gutterBottom style={{fontWeight:"bolder"}} >
                                        Biomarkers
                                    </Typography>
                                    <ol>
                                        {packageDetails && packageDetails.panel_detail && packageDetails.panel_detail.map((item, index) => {
                                            return <li key={index}>{item.biomarks}</li>
                                        })}
                                    </ol>

                                </Grid>
                                {
                                    _package.homeservice &&
                                        _package.homeservice.find((o) => o.diagnosticspartner === partnername)
                                        ?
                                        _package.homeservice.filter((i) => i.areaRef === areaState.value).map((item, index) => {
                                            return (
                                                <Grid key={index} style={{display:"flex",justifyContent:"space-around",alignItems:"center"}}
                                                // justifyContent="flex-start" alignItems="flex-start"
                                                    // className={[classes.homeSampleStyle, !enableHomeService ? classes.disCls : '']} 
                                                    className={[classes.homeSampleStyle]} 

                                                    >
                                                        <Grid xs={1}>
                                                    <input type='checkbox' style={{ marginLeft: '25%' }} checked={isHomeSampleSelected} onChange={(e) => {
                                                        setIsHomeSampleSelected(e.target.checked);
                                                        var newHomeSelectedServices = _.cloneDeep(homeSelectedServices);
                                                        if (e.target.checked) {
                                                            newHomeSelectedServices.push(item);
                                                            setSelectedHomeServices(newHomeSelectedServices);
                                                            onAddHomeService(item);
                                                        } else {
                                                            newHomeSelectedServices = newHomeSelectedServices.filter((i) => i.uuid !== item.uuid);
                                                            setSelectedHomeServices(newHomeSelectedServices);
                                                            onRemoveHomeService(item);
                                                            // onHomeSampleOptionChange(e, item.uuid, item);
                                                        }

                                                    }
                                                    } />
                                                    </Grid>

                                                    {/* <Grid > */}
                                                        <Grid xs={7}>
                                                    <Typography  variant="body1" >
                                                        Home Sample Collection
                                                    </Typography>
                                                    </Grid>
                                                    <Grid xs={1}>
                                                    <Typography
                                                        // align="center"
                                                        variant="h3"
                                                        style={{ fontWeight: "900", color: "#002931" }}>
                                                        ₦ 
                                                    </Typography>
                                                    </Grid>
                                                    <Grid xs={3}>
                                                    <Typography
                                                        // align="center"
                                                        variant="h3"
                                                        style={{ fontWeight: "900", color: "#002931" }}>
                                                        {item.doctallsexclusivediscountedprice}
                                                    </Typography>
                                                    </Grid>
                                                    {/* </Grid> */}
                                                </Grid>
                                            )
                                        })
                                        : null
                                }

                                <Grid  direction='row' className={classes.homeSampleStyle} style={{ marginTop: '2%' }}>
                                    <Grid style={{display:"flex",justifyContent:"space-around",alignItems:"center"}}>
                                    <Grid item xs={7}  >
                                        <Typography 
                                        // align="center"
                                         variant="body1" style={{ marginLeft: '10%' }}>
                                            Selected Package Cost
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={1} >
                                        <Typography
                                            // align="center"
                                            variant="h6"
                                            style={{ fontWeight: "900", color: "#002931" ,marginLeft:"1px"}}
                                        >
                                            ₦ 
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={4} >
                                    <Typography
                                            // align="center"
                                            variant="h6"
                                            style={{ fontWeight: "900", color: "#002931" ,marginLeft:"2%"}}

                                        >
                                            {Math.round(_package.amount)}
                                        </Typography>
                                    </Grid>
                                    </Grid>



                                </Grid>
                                <Grid item  style={{width:"350px"}}>
                                    {addedToCart ? <Button
                                        variant="contained"
                                        className={classes.addToCartButton}
                                        style={{ marginTop: '2%' }}
                                        onClick={() => { setAddedToCart(false); onRemoveFromCart(_package) }}
                                    >
                                        Remove From Cart
                                    </Button> : <Button
                                        variant="contained"
                                        className={classes.addToCartButton}
                                        style={{ marginTop: '2%' }}
                                        onClick={() => { setAddedToCart(true); onAddToCart(_package) }}
                                    >
                                        Add To Cart
                                    </Button>}
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                    </Col>
                    </Row>
                    </div>
                {/* </Grid> */}
            </Grid>
        </>
    )
}